/* global window */
'use strict';

module.exports = require('./ponyfill')(global || window || this);



/** WEBPACK FOOTER **
 ** ./src/app/modules/login/~/symbol-observable/index.js
 **/